"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTheme;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _createTheme = _interopRequireDefault(require("../styles/createTheme"));
var _base = _interopRequireDefault(require("./base"));
var _defaultMuiTheme = require("./base/defaultMuiTheme");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function deepMerge(baseTokens, themeTokens) {
  return (0, _deepmerge.default)(baseTokens, themeTokens);
}
function createTheme(options) {
  return (0, _createTheme.default)(_objectSpread(_objectSpread({}, _defaultMuiTheme.defaultMuiTheme), {}, {
    // We might want to get rid of the default MUI theme once our components rely on the Extended theme
    busbud: deepMerge(_base.default, options)
  }));
}